import { formControl } from '@al00x/forms';
import { Component, inject, signal } from '@angular/core';
import { Validators } from '@angular/forms';
import { PageEditorComponent, PageEditorData, TermsConditionService } from '@core';
import { TermsAndConditionsType } from '@models';
import { Observable } from 'rxjs';

@Component({
  selector: 'lib-privacy-policy',
  imports: [PageEditorComponent],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css',
})
export class PrivacyPolicyComponent {
  readonly termsConditionService = inject(TermsConditionService);
  readonly type = TermsAndConditionsType.PrivacyPolicy;
  isLoadingData = signal(true);
  
  pageEditorData: PageEditorData = {
    arabic: { controller: formControl<string>(undefined, Validators.required), title: 'سياسة الخصوصية' },
    english: { controller: formControl<string>(undefined, Validators.required), title: 'Privacy Policy' },
  };

  constructor() {
    this.termsConditionService.getTermsAndConditionForAdmin(this.type).subscribe({
      next: (res) => {
        this.pageEditorData.arabic.controller.setValue(res.termsAndConditionsDTO.arabicValue);
        this.pageEditorData.english.controller.setValue(res.termsAndConditionsDTO.englishValue);
        this.isLoadingData.set(false);
      },
      error: (error) => {
        console.error('Error loading privacy policy data:', error);
        snackbar$.error('Error loading privacy policy data');
        this.isLoadingData.set(false);
      }
    });
  }

  updateFunction = (): Observable<string> => {
    return this.termsConditionService.updateTermsAndConditions({
      type: this.type,
      value: {
        arabic: this.pageEditorData.arabic.controller.value,
        english: this.pageEditorData.english.controller.value,
      },
    });
  }
}
